import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import './styles.css';

class BrowserWarning extends React.Component {

  static propTypes = {
    header: PropTypes.string,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    isIE: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      isHidden: false,
    };
  }

  hideWarning() {
    this.setState(state => ({ ...state, isHidden: true }));
  }

  render() {
    const { header, description, buttonText, isIE } = this.props;
    const { isHidden } = this.state;
    return isIE ? (
      <div className={isHidden ? 'hide browser-warning' : 'browser-warning'}>
        <div>
          <h3>
            <img src="/assets/images/varning.svg" alt="" />
            {header}
          </h3>
          <p>{description}</p>
          <Button onClick={() => this.hideWarning()}>{buttonText}</Button>
        </div>
      </div>
    ) : null;
  }
}

export default BrowserWarning;



// WEBPACK FOOTER //
// ./src/components/organisms/BrowserWarning/index.js